














import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class Card extends Vue {
  @Prop({ default: false }) hoverable!: boolean;
  @Prop({ default: false }) highlighted!: boolean;
};
